import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { createContext, useContext, useMemo } from "react";
import { pluck } from "ramda";
import { useQuery } from "react-query";
import { searchOrganizations, getOrganizationsMeta } from "@webapi/api";
import { isNotEmptyArray } from "utils/validation";
import { jsx as _jsx } from "react/jsx-runtime";
export var OrganizationsContext = /*#__PURE__*/createContext({});
export var OrganizationsContextProvider = function OrganizationsContextProvider(props) {
  var _useQuery = useQuery(["organizationsSearch"], searchOrganizations, {
      initialData: []
    }),
    organizations = _useQuery.data;
  var orgIds = organizations && pluck("id", organizations);
  var _useQuery2 = useQuery(["organizationsMetadata", orgIds], function () {
      return getOrganizationsMeta(orgIds);
    }, {
      initialData: [],
      enabled: isNotEmptyArray(organizations)
    }),
    orgMetadata = _useQuery2.data;
  var simpleOrganizationsMap = useMemo(function () {
    var mappedOrganizations = new Map();
    organizations.forEach(function (organization) {
      mappedOrganizations.set(organization.id, organization);
      if (mappedOrganizations.get(organization.type)) mappedOrganizations.set(organization.type, [organization].concat(_toConsumableArray(mappedOrganizations.get(organization.type))));else mappedOrganizations.set(organization.type, [organization]);
    });
    return mappedOrganizations;
  }, [organizations]);
  var organizationsMetadataMap = useMemo(function () {
    var mappedOrganizations = new Map();
    orgMetadata.forEach(function (organization) {
      mappedOrganizations.set(organization.id, organization);
      if (mappedOrganizations.get(organization.type)) mappedOrganizations.set(organization.type, [organization].concat(_toConsumableArray(mappedOrganizations.get(organization.type))));else mappedOrganizations.set(organization.type, [organization]);
    });
    return mappedOrganizations;
  }, [orgMetadata]);
  var lookupOrganization = function lookupOrganization(id) {
    return organizationsMetadataMap.get(id) || simpleOrganizationsMap.get(id) || {};
  };
  var careUnitRegions = organizationsMetadataMap.get("Sjukvardsregion") || simpleOrganizationsMap.get("Sjukvardsregion") || [];
  var regions = organizationsMetadataMap.get("Region") || simpleOrganizationsMap.get("Region") || [];
  var municipalty = organizationsMetadataMap.get("Kommun") || simpleOrganizationsMap.get("Kommun") || [];
  var hospitals = organizationsMetadataMap.get("Sjukhus") || simpleOrganizationsMap.get("Sjukhus") || [];
  var careUnits = organizationsMetadataMap.get("Vardenhet") || simpleOrganizationsMap.get("Vardenhet") || [];
  return /*#__PURE__*/_jsx(OrganizationsContext.Provider, {
    value: {
      careUnitRegions: careUnitRegions,
      regions: regions,
      municipalty: municipalty,
      hospitals: hospitals,
      careUnits: careUnits,
      lookupOrganization: lookupOrganization
    },
    children: props.children
  });
};
export var useOrganizationsContext = function useOrganizationsContext() {
  return useContext(OrganizationsContext);
};